<template>
    <div>
        <div class="row">
            <b-tabs small card class="w-100">
                <template v-for="(pack, idx) in packs">
                    <b-tab :active="idx===0" no-body :title="pack.name" class="pretty-scroll scroll-500" v-if="!isExpired(pack) && isDueDate(pack)">
                        <pack-banner source="store" :pack="pack"></pack-banner>
                    </b-tab>
                </template>
            </b-tabs>

        </div>
            <div>
                <div class="col border-top pt-3 font-weight-bold mt-3 text-center">
                    ISSUES WITH YOUR PURCHASE? CONTACT US:<br />
                    support@meowplayground.com
                </div>
            </div>
        </div>
</template>
<script>
    import PackBanner from './PackBanner.vue';
    import moment from 'moment'
    export default {
        data() {
            return {
                packs: []
            }
        },
        props: ["id", "baseURL"],
        computed: {

        },
        components: {
            PackBanner
        },
        methods: {
            isDueDate(pack){
                if(typeof pack.starts_at === "undefined" || pack.starts_at === null)
                    return true;
                if(moment().isSameOrAfter(moment(pack.starts_at))){
                    return true;
                }
                return false;
            },
            isExpired(pack){
                if(typeof pack.ends_at === "undefined" || pack.ends_at === null)
                    return false;
                if(moment(pack.ends_at).isSameOrAfter(moment())){
                    return false;
                }
                return true;
            }
        },
        mounted: function () {
            this.$http.get("/purchase_packs").then((res) => {
                this.packs = res.data
            });
        }
    }
</script>
<style scoped>

.price{
    color: #fffe00;
    margin-left: 10px;
    font-size: 2.5rem;    
}
.title{
    position: absolute;
    text-align: center;
    width:100%;
}
.title h2{
    font-weight: bold;
    color: #fff;
    font-family: arial;
    margin-top: 0.5rem;
}
.chk-btn{
    width:238.4px;
}
.holder{
    margin:auto;
    margin-top:5px;
    background-position: bottom;
    background-size: cover;
    position:relative;
}
.style-1{
    /*width:960px;
    height:336px;*/
    aspect-ratio: 1200/420;
}
.style-2{
    /*width:960px;
    height:336px;*/
    padding-top: 40px;
    aspect-ratio: 1200/467;
}
.window{
    margin:auto;
    background-repeat: no-repeat;
    width:97.6px;
    height:66.4px;
    background-image: url('/images/store/window.png');
    text-align: center;
    background-size: contain;
    padding-top:10px;
    background-position: 20px;
}
.txt{
    color:#fff;
    text-align: center;
    margin:auto;
    line-height: 1;
    background: rgba(0,0,0,0.5);
}
.awards{
    max-width:60%;
    padding-top:8%;
    margin-left:10px;
}
.award{
    width: fit-content;
}
.award-icon{
    max-width: 40%;
    margin: auto;
}
</style>